import React from 'react'
import { GridColDef } from '@mui/x-data-grid-pro'
import { TFunction } from 'i18next'
import { getInfoTooltipHeaderCell } from 'components/Shared/MuiTable/Cell/InfoTooltipHeaderCell'
import { SEARCH_PARAMS, getSearchParams } from 'components/utils/url'
import { ActionTextCell, ActionTextProps } from 'components/Shared/MuiTable/Cell/RouteLinkCell'
import { REGISTRATION_VIEW_ENUM } from 'state/review'

export interface RegistrationRowProps {
    id: string
    pending: ActionTextProps
    awaitingResponse: ActionTextProps
    accepted: ActionTextProps
    joinedCampaign: ActionTextProps
}

export const getColumns = (t: TFunction): GridColDef[] => {
    const cols: GridColDef[] = [
        {
            field: 'pending',
            type: 'string',
            headerName: t('statusLabel.pending'),
            flex: 1,
            renderCell: params => <ActionTextCell {...params} />,
            sortable: false,
            filterable: false,
            renderHeader: getInfoTooltipHeaderCell({
                width: 255,
                description: t('statusLabel.pendingRegistrationTooltipDescription'),
                options: {
                    mr: 0,
                },
            }),
        },
        {
            field: 'awaitingResponse',
            type: 'string',
            headerName: t('statusLabel.awaitingResponse'),
            flex: 1,
            renderCell: params => <ActionTextCell {...params} />,
            sortable: false,
            filterable: false,
            renderHeader: getInfoTooltipHeaderCell({
                width: 255,
                description: t('statusLabel.awaitingResponseTooltipDescription'),
                options: {
                    mr: 0,
                },
            }),
        },
        {
            field: 'accepted',
            type: 'string',
            headerName: t('statusLabel.accepted'),
            flex: 1,
            renderCell: params => <ActionTextCell {...params} />,
            sortable: false,
            filterable: false,
            renderHeader: getInfoTooltipHeaderCell({
                width: 255,
                description: t('statusLabel.acceptedTooltipDescription'),
                options: {
                    mr: 0,
                },
            }),
        },
        {
            field: 'joinedCampaign',
            type: 'string',
            headerName: t('statusLabel.joinedCampaign'),
            flex: 1,
            renderCell: params => <ActionTextCell {...params} />,
            sortable: false,
            filterable: false,
            renderHeader: getInfoTooltipHeaderCell({
                width: 255,
                description: t('statusLabel.joinedCampaignTooltipDescription'),
                options: {
                    mr: 0,
                },
            }),
        },
    ]
    return cols
}

const getActionsCell = (text: string, viewType: REGISTRATION_VIEW_ENUM) => {
    const searchParams = getSearchParams({
        add: [{ key: SEARCH_PARAMS.viewType, value: viewType }],
    })
    return {
        actionTitle: text,
        url: searchParams,
        dataTestId: 'test-action-text-cell-' + viewType,
    }
}

export const getRows = (
    campaignUuid: string,
    pendingNumber: string,
    awaitingResponseNumber: string,
    acceptedNumber: string,
    joinedCampaignNumber: string,
): RegistrationRowProps[] => {
    return [
        {
            id: campaignUuid,
            pending: getActionsCell(pendingNumber, REGISTRATION_VIEW_ENUM.PENDING),
            awaitingResponse: getActionsCell(awaitingResponseNumber, REGISTRATION_VIEW_ENUM.AWAITING_RESPONSE),
            accepted: getActionsCell(acceptedNumber, REGISTRATION_VIEW_ENUM.ACCEPTED_INVITES),
            joinedCampaign: getActionsCell(joinedCampaignNumber, REGISTRATION_VIEW_ENUM.JOINED_CAMPAIGN),
        },
    ]
}
